import React, {useEffect, useRef} from "react";
import {WdiModalAppProps} from "@/components/WdiControls";
import {ProFormInstance} from "@ant-design/pro-form";
import {WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {ResponseStatus} from "@/utils/request";
import {Checkbox, Form, message} from "antd";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {FormSp} from "@/services/sales/sp";

const PrepayTypeEdit: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  useEffect(() => {
    if (props.id) {
      const formId = Number(props.id)
      formRef.current?.setFieldsValue({
        formId: formId,
      })
      FormSp.get(formId).then(res => {
        formRef.current?.setFieldsValue({
          isForPrePay: res?.data.isForPrePay
        });
      })
    }

  }, [props.id])
  return (
    <>
      <WdiModalForm
        formRef={formRef}
        labelCol={{span: 6}}
        wrapperCol={{span: 12}}
        labelAlign='left'
        layout="horizontal"
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose ? props.onClose() : null
          },
          destroyOnClose: true,
          maskClosable: false
        }}
        onFinish={async (values) => {
          const {staffId, ...entity} = values;
          entity.staffId = WdiSelectFormat.getvalue(staffId);
          // let pageTypeId = 0;
          // if (props.data.pageTypeId === Enum.PageType.PAYMENT_CUST_SYS) {
          //     pageTypeId = Enum.PageType.PAYMENT_CUST_SYS;
          // } else {
          //     pageTypeId = Enum.PageType.PAYMENT_SOLD_TO;
          // }


          entity.pageTypeId = props.data?.form.pageTypeId;
          const response = await FormSp.Buttons.modifyPrepay(entity);
          if (response.code != ResponseStatus.SUCCESS) {
            message.error(response.message);
            return false;
          }
          message.success('修改成功!');
          if (props.onSave) {
            props.onSave();
          }
          return true;
        }}
      >
        <Form.Item name='formId' hidden={true}>
        </Form.Item>
        <Form.Item name="isForPrePay" label="是否冲销预付" valuePropName="checked">
          <Checkbox/>
        </Form.Item>
      </WdiModalForm>
    </>
  )
}
export default PrepayTypeEdit;
